import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  SendRequestCallback,
  CollectionsFormData,
  CollectionsSummary,
  parseCollectionFormDataToParams,
} from "../../types";
import { showError } from "../notifications";

interface CreateCollectionType {
  sendRequest: SendRequestCallback<any, any, CollectionsSummary[]>;
  form: CollectionsFormData;
}

export const getCollectionsSummary = createAsyncThunk(
  "report/getCollectionSummary",
  async ({ sendRequest, form }: CreateCollectionType, { dispatch }) => {
    try {
      const response = await sendRequest("get")({
        url: `/org/collectionsReport/?${parseCollectionFormDataToParams(form)}`,
      });
      return response.data || [];
    } catch (err) {
      dispatch(showError("Failed to get Collection summary"));
    }
  }
);
